import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../../base/ui/components/web/Dialog";
import { saveCaption } from "../../functions";
import { setEnableSubtitle } from "../../../subtitles/actions.any";
import { checkOwnerCaption } from "../../../base/util/functions";
const DialogSaveCaption = ({ liveCaptionSaveStatus }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _state = useSelector((state) => state);
    const handleSubmit = () => {
        webSocket.emit("enable_save_live_caption_client", liveCaptionSaveStatus === 1 ? 0 : 1);
        webSocket.emit("enable_live_caption_room_client", true);
        dispatch(saveCaption(!(liveCaptionSaveStatus === 1)));
        dispatch(setEnableSubtitle(true));
        checkOwnerCaption(dispatch, _state);
    };
    return (React.createElement(Dialog, { titleKey: liveCaptionSaveStatus === 1 ? t('saveCaption.titleDialogDontSave') : t('saveCaption.titleDialogSave'), onSubmit: handleSubmit, ok: {
            translationKey: "dialog.confirm",
        }, hideTooltip: true, disableEnter: true },
        React.createElement(Box, null,
            React.createElement(Typography, null, liveCaptionSaveStatus === 1 ? t('saveCaption.dontsave') : t('saveCaption.save')))));
};
export default DialogSaveCaption;
